
import React, { useEffect, useState, useRef } from 'react';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { useSelector } from "react-redux";
import moment from "moment";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import {DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom} from "../../../components/TapUi/index";
import DownloadFile from "../../../services/DownloadFile";
import InputItemSearch from '../../includes/ui/InputItemSearch';
import TapSelect from "../../../components/ui/TapSelect";
import Helmet from 'react-helmet';
import swal from "sweetalert";
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapHelper from '../../../services/TapHelper';

function ItemWisePoNonFinancialReport(props) {
    const reportUrl         =   INVENTORY_API_BASE_URL_2 + '/report/item_wise_po_non_financial';
    const formDataUrl       =   INVENTORY_API_BASE_URL_2 + '/report/item-wise-purchase-order/form_data';
    const access_token      =   useSelector(state => state.auth.access_token);
    const allPeriods        =   useSelector(state => state.app.all_periods ? state.app.all_periods : []);
    const allWarehouses     =   useSelector(state => state.app.warehouses ? state.app.warehouses   : []);
    const itemTags          =   useSelector(state => state.app.item_tags ? state.app.item_tags : []);
    const report_listing    =   useSelector(state => state.app.report_listing ? state.app.report_listing : []);

    let initFilterFormData  =   {
        show                    :   true,
        per_page                :   50,
        form_data_loaded        :   false,
        loading                 :   false,
        isQueryData             :   false,
        isSearchElement         :   false,
        tagged_user_filter      :   '',
        search_transaction_id   :   '',
        search_warehouse_ids    :   [],
        search_item_ids         :   [],
        search_item_tags        :   [],
        search_status_ids       :   [],
        search_priority         :   '',
        search_manufacturer_ids :   [],
        date_range              :   '',
        date_range_start        :   '',
        date_range_end          :   '',
        search_workstation_ids  :   [],
        search_asset_ids        :   [],
        search_employee_ids     :   [],
        tagged_user_ids         :   [],
    }

    let formDataLabel       =   {
        tagged_user_filter      :   'User Tagging : ',
        search_transaction_id   :   'PO Number : ',
        search_warehouse_ids    :   'Warehouse : ',
        search_workstation_ids  :   'WorkStation : ',
        search_asset_ids        :   'Asset : ',
        search_item_ids         :   'Items : ',
        search_item_tags        :   'Item Tags : ',
        search_status_ids       :   'Status : ',
        search_priority         :   'Search Priority : ',
        search_manufacturer_ids :   'Manufacturer : ',
        date_range              :   'Date Range : ',
        search_employee_ids     :   'Employees : ',
        tagged_user_ids         :   'Tagged Users : ',
    };

    const types             =   [
         { value: 'tagged_me', label: 'My Tagged PO' },
         { value: 'created_by_me', label: 'PO Created By Me' },
    ];
    
    const [filterFormData, setFilterFormData]       =   useState(initFilterFormData)
    const [searchedElems, setSearchedElems]         =   useState([]);
    const [formData, setFormData]                   =   useState({
                                                                    allWarehouses       :   [],
                                                                    allItemTags         :   [],
                                                                    allPeriods          :   [],
                                                                    searchedVendor      :   [],
                                                                    allStatusOptions    :   [],
                                                                    allPriorityOptions  :   [],
                                                                    manufactures        :   [],
                                                                    allUsers            :   [],

                                                                    searchedItem        :   [],
                                                                    searchedAssets      :   [],
                                                                    searchedEmployees   :   [],
                                                                 })
    const [listingData, setListingData]             =   useState({ 
                                                                    loading             :   false,
                                                                    show                :   false,
                                                                    reportDownloadBtn   :   false,
                                                                    reportDownloading   :   false,
                                                                    data                :   [],
                                                                    meta                :   null,
                                                                    page                :   1
                                                                });

    const criteriaRef   =   useRef()
    const [criteriaHeight ,setCriteriaHeight ] =    useState(0)
    const [reportName , setReportName]         =    useState(null)
    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };
    useEffect(() => {
        updateCriteriaHeight();
        if (filterFormData.show && !filterFormData.form_data_loaded) {
            loadFormData(props);
        }
    }, [filterFormData.show]);

   

    const loadFormData = (props) => {
        const report_name = props?.location?.pathname ? props.location.pathname.split('/')[2] : '';
        const reportData = report_listing.length > 0 ? report_listing.filter(d => d.key === report_name) : [];
        setFilterFormData(pre => ({ ...pre, loading: true }));
        HttpAPICall.withAthorization('GET', formDataUrl, access_token, {}, null, (resp) => {
            const { manufacturers, priorities, purchase_order_type, status, users, workstations } = resp.data;
            setFilterFormData(pre => ({ ...pre, form_data_loaded: true }))
            setReportName(reportData.length > 0 ? reportData[0] : null)
            setFormData(pre => ({
                ...pre,
                allPeriods: [...allPeriods, { key: 'custom', display: 'Custom Date Range' }],
                manufactures: manufacturers.length > 0
                    ? manufacturers.map((m) => { return { value: m.id, label: m.name } }) : [],

                allStatusOptions: status.length > 0
                    ? status.map((s) => { return { value: s.id, label: s.name, level: s.level }; }) : [],

                allPriorityOptions: priorities.length > 0
                    ? priorities.map((s) => { return { value: s.key, label: s.name }; }) : [],

                allItemTags: itemTags.length > 0
                    ? itemTags.map((s) => { return { value: s.id, label: s.name }; }) : [],

                workstations: workstations.length > 0
                    ? workstations.map((w) => { return { value: w.id, label: `${w.workstation_name} (${w.workstation_nickname})` } }) : [],

                allUsers: users
                    ? users.map((s) => { return { value: s.id, label: s.full_name, site_ids: s.linked_sites }; }) : [],

                allWarehouses: allWarehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` } }),


            }))
        }).then(() => {
            setFilterFormData(pre => ({ ...pre, loading: false }))
        });
    }

    const loadListData      =   (page = 1)  =>  {
        setListingData(pre => ({...pre, loading : true}));
        setFilterFormData(pre => ({...pre, isSearchElement : false}));
        let params = {
            page,
            action: "data" ,
            ...TapHelper.pick(filterFormData, ["tagged_user_filter", "search_transaction_id", "search_warehouse_ids", "search_item_ids", "search_item_tags", "search_status_ids", "search_priority", "search_manufacturer_ids", "date_range", "date_range_start", "date_range_end", "search_workstation_ids", "search_asset_ids", "search_employee_ids", "tagged_user_ids"])
        };      

        HttpAPICall.withAthorization('GET', reportUrl, access_token, params, null, (resp) => {
            const respData  =  resp.data;
            let meta        =  TapHelper.pick(respData, ['from', 'to', 'total', 'last_page', 'per_page', 'current_page']);
            setListingData(pre => ({
                ...pre,   
                reportDownloadBtn: true,
                data : respData.data,
                meta
            }))
        }).then(() => setListingData(pre => ({...pre, loading : false})));    
          
    }

    const closeReport       =   ()  =>  props.history.push({ pathname: `/report` })

    const toggleFilterForm      =  (show)   =>  {
        setFilterFormData(pd => ({ ...pd, show: show }))
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }
    const handleChangeOption    =   (selectedOption, optionName)  => {
        
        let data    =   (Array.isArray(selectedOption)) 
            ? selectedOption.map(op => op.value) 
            : selectedOption 
                ? selectedOption.value
                : ""
        
        setFilterFormData(pre => ({...pre, [optionName] : data}))
    }

    const inputFieldHandler =   (e) => {
        setFilterFormData(pre => ({...pre, [e.target.name] : e.target.value}))
    }

    const reportFilterFormSubmit = (e) => {
        e && e.preventDefault()
 
        let runApi              =   true;
        
        if(runApi) {
            toggleFilterForm(false);
            let serachFormKeys          =   Object.keys(filterFormData);
            let searchedElems           =   [];
            let itemSearchParams        =   {};
            serachFormKeys.map((key)        =>  {
                let label               =   formDataLabel[key];
                let value               =   filterFormData[key];
                if(value && value.toString().length > 0) {
                    itemSearchParams[key]      =   value;
                    if(label) {
                        let show_val            =   value;
                        if(key == 'tagged_user_filter') {
                            show_val            =  types.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_warehouse_ids') {
                            show_val            =   formData.allWarehouses.filter((s) => filterFormData.search_warehouse_ids.includes(s.value)).map(s => s.label);
                        }
                        if(key == 'search_item_ids') {
                            show_val            =   formData.searchedItem ? formData.searchedItem.map(s => s.display_label).join(', ') : '';
                        }
                        if(key == 'search_item_tags') {
                            show_val            =   formData.allItemTags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_transaction_id') {
                            show_val            =   filterFormData ? filterFormData.search_transaction_id : '';
                        }
                        
                        
                        if(key == 'search_status_ids') {
                            show_val            =   formData.allStatusOptions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_priority') {
                            show_val            =   formData.allPriorityOptions.filter((s) => value.includes(s.value)).map(s => s.label);
                        }
                        if(key == 'search_manufacturer_ids') {
                            show_val            = formData.manufactures.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_workstation_ids') {
                            show_val            =   formData.workstations.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
                        if(key == 'search_asset_ids') {
                            show_val            =   formData.searchedAssets ? formData.searchedAssets.map(s => s.display_label).join(', ') : '';
                        }
                        if(key == 'search_employee_ids') {
                            show_val            =   formData.searchedEmployees ? formData.searchedEmployees.map(s => s.label).join(', ') : '';
                        }
                        if(key == 'tagged_user_ids') {
                            show_val            =   formData.allUsers.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                        }
    
                        if(key == 'date_range') {
                            let  start_range         =      moment(filterFormData.date_range_start).format('DD-MMM-YYYY');
                            let end_range            =      moment(filterFormData.date_range_end).format('DD-MMM-YYYY')
                                let display_custom      =      `Custom Date Range (${start_range} - ${end_range})`
                                show_val                 =     formData.allPeriods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                        }
                        searchedElems.push(label + `<b>${show_val}</b>`);
                    }
                }
            })
            
            setFilterFormData(pre => ({...pre, isSearchElement : true}))
            setSearchedElems(searchedElems);
            setListingData(pre => ({...pre, show : true}))
            loadListData(1)
        }

    }


    const downloadReport    =   ()  => {
        let params = {
            action: 'download',
            ...TapHelper.pick(filterFormData, ["tagged_user_filter", "search_transaction_id", "search_warehouse_ids", "search_item_ids", "search_item_tags", "search_status_ids", "search_priority", "search_manufacturer_ids",  "date_range", "date_range_start", "date_range_end", "search_workstation_ids", "search_asset_ids", "search_employee_ids", "tagged_user_ids"])
        };


        if(params.overdue_aging != '' || params.due_soon_aging != '') {
            reportDownloadApiCall(params);
        } else if(params.date_range == '') {
            swal({ 
                title: "Download", icon: "warning", buttons: ["Cancel", "Okay"],
                text: "The download will be for Current Quarter, in case you want a different Period then apply the criteria before downloading.",
            }).then(willDownload => {
                if (willDownload) { reportDownloadApiCall({...params, date_range: "current_quarter"}); }
            });
        }
        
    }

    const reportDownloadApiCall     =   (formData)  =>  {
        setListingData(pre => ({
            ...pre,
            reportDownloading : true
        }));

        HttpAPICall.withAthorization('GET', reportUrl, access_token, formData , {} , (response) => DownloadFile.file(null,response.data.msg, response.data.navigation,props))
        .then(() => {
            setListingData(pre => ({
                ...pre,
                reportDownloading : false
            }))
        });
    }

    const reportFilterFormJsx = () => {
        return (
            <form onSubmit={reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')}>
                 <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">PO For</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={types}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'tagged_user_filter')}
                            value={types.find(u => u.value == filterFormData.tagged_user_filter)}
                            isSearchable={true}
                            isClearable={true}
                            placeholder="Select PO For"
                        />
                    </div>
                </div>
                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Item</label>
                    <div className="col-sm-6">
                        <InputItemSearch
                            placeholder="Search Item"
                            isMulti={true}
                            changeEvent={(selectedOption) => {
                                handleChangeOption(selectedOption, 'search_item_ids');
                                setFormData(pre => ({...pre, searchedItem : selectedOption}))
                            }}
                            value={formData.searchedItem.length > 0 ? formData.searchedItem.map(a => { a.label = a.display_label; return a; }) : []}
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Item Tags</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allItemTags}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption,'search_item_tags')}
                            value={formData.allItemTags.filter(u => filterFormData.search_item_tags.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            placeholder="Select Item Tags"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Tagged User</label>
                    <div className="col-sm-6">
                        <TapSelect
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            placeholder="Tagged User"
                            options={formData.allUsers}
                            value={formData.allUsers.filter(s => filterFormData.tagged_user_ids.includes(s.value))}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'tagged_user_ids')}
                        />
                    </div>
                </div>

                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Manufacturer</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.manufactures}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_manufacturer_ids')}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={formData.manufactures.filter(s => filterFormData.search_manufacturer_ids.includes(s.value))}
                            placeholder="Select Manufacturer"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Warehouse</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allWarehouses}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_warehouse_ids')}
                            value={formData.allWarehouses.filter(u => filterFormData.search_warehouse_ids.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            placeholder="Select Warehouses"
                        />
                    </div>
                </div>
               
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">PO Number</label>
                    <div className="col-sm-6">
                        <input
                            name="search_transaction_id"
                            type="text"
                            value={filterFormData.search_transaction_id}
                            className="form-control"
                            autoComplete="off"
                            onChange={(e) => inputFieldHandler(e)}
                            placeholder="Please Enter Transaction ID"
                        />
                    </div>
                </div>

               

                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Priority</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allPriorityOptions}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_priority')}
                            value={formData.allPriorityOptions.find(u => u.value == filterFormData.search_priority)}
                            isSearchable={true}
                            isClearable={true}
                            placeholder="Select Priority"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Status</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={formData.allStatusOptions}
                            changeEvent={(selectedOption) => handleChangeOption(selectedOption, 'search_status_ids')}
                            isMulti={true}
                            isClearable={true}
                            value={formData.allStatusOptions.filter(s => filterFormData.search_status_ids.includes(s.value))}
                            placeholder="Select Status"
                        />
                    </div>
                </div>


                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">PO Transaction Period</label>
                    <div className="col-sm-6">
                        <PeriodSelectionWithCustom
                            periods={formData.allPeriods}
                            value={filterFormData.date_range}
                            startDate={filterFormData.date_range_start}
                            endDate={filterFormData.date_range_end}
                            onSelectPeriod={(period, startDate, endDate) => {
                                setFilterFormData((pre) => ({
                                    ...pre,
                                    date_range: period,
                                    date_range_start: startDate ? startDate : null,
                                    date_range_end: endDate ? endDate : null
                                }))
                            }}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={false} className="btn btn-primary px-4">Show Report</button>
                    </div>
                    <hr />
                </div>
            </form>
        );
    }

    const pageTitleBarJsx       =   ()  =>  {
        return (<div className="page_title row m0">
            <div className="col-sm-12">
                <h3><tapIcon.FontAwesomeIcon icon={tapIcon.faCubes} /> {reportName?.name}</h3>
                <div className="text-end pt-2">
                    <button type="button" onClick={() => toggleFilterForm(!filterFormData.show)} className="btn btn-secondary">Change Filter</button>
                    {
                        listingData.reportDownloadBtn && 
                    <> 
                        <button disabled={listingData.reportDownloading} type="button" className="btn btn-secondary" onClick={downloadReport}>
                        <tapIcon.FontAwesomeIcon icon={tapIcon.faDownload} />
                        {listingData.reportDownloading ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />) : null }
                        </button>
                    </>
                    }
                    <button type="button" className="btn btn-secondary" onClick={closeReport}>
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                    </button>
                </div>
            </div>
        </div>);
    }
  
    const listData   =   () => {
        return (<>
            <div ref={criteriaRef}
            style={{
                position: 'sticky',
                top: 0,
                background: 'white',
            }}>
                <DisplaySearchCriteria searchedElems={searchedElems} />
            </div>
            <table className="table table-sm table-bordered align-middle bg-white">
                <thead className="align-middle table-secondary" style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                     <tr>
                        <th className='text-center' style={{ width: "9%" }}>PO Number</th>
                        <th className='text-center' style={{ width: "7%" }}>PO Date</th>
                        <th className="text-center" style={{ width: "16%" }}>Warehouse</th>
                        <th className="text-center" style={{ width: "18%" }}>Item Name</th>
                        <th className='text-center' scope="col" style={{ width: "8%" }}>Status</th>
                        <th className='text-end' scope="col" style={{ width: "5%" }}  >PO Qty</th>
                        <th className='text-end' scope="col" style={{ width: "5%" }} >Received</th>
                        <th className='text-end' scope="col" style={{ width: "5%" }} >Cancelled</th>
                        <th className='text-end' scope="col" style={{ width: "5%" }} >Pending</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        listingData.loading 
                        ? <tr className='text-center'><td colSpan={11}><Loader/></td></tr>
                        :
                        listingData?.data && listingData?.data.length > 0
                        ? (listingData?.data.map((rowData, k) => {
                          
                                return (<tr key={k} >
                                    <td  className='text-center'>{rowData.transaction_id}</td>
                                    <td className='text-center'>{rowData.transaction_date_display}</td>
                                    <td className='text-center'>{rowData.warehouse_name}</td>
                                    <td className='text-center'>{rowData.item_name} <br />
                                        <small className='form-text'><b>Code : </b> {rowData.item_code}</small></td>
                                    <td className='text-center'>{rowData.status_name}</td>
                                   <td className='text-end'>{rowData.qty}</td>
                                    <td className='text-end'>{rowData.received_qty}</td>
                                    <td className='text-end'>{rowData.cancelled_qty}</td>
                                    <td className='text-end'>{rowData.pending_qty}</td>
                                </tr>);
                           
                        }))
                        : (<tr><td className="text-center" colSpan={10}>No Record Found</td></tr>)
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={listingData.meta} onPageChange={(e) => loadListData(e.selected + 1)} keyName="PO Items"/>
        </>)
    }

    return  <ApplicationLayout>
        <Helmet><title>Item Wise PO Non Financial - Report</title></Helmet>
            {pageTitleBarJsx()}
        <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        <div className={["bg-white", filterFormData.show ? 'tbShow' : 'tbHide'].join(" ")} >
                            {
                                filterFormData.loading ? <Loader/> :  reportFilterFormJsx()
                            }
                        </div>
                        { listingData.show &&  listData()}
                    </div>
                </div>
          </div>
    </ApplicationLayout>
}

export default ItemWisePoNonFinancialReport;